module.exports = __webpack_public_path__ + "assets/optimizely.09fcbbcd.svg";